<template>
    <div class="row ml-xl-4 m-0">
        <div class="col-md-12 col-sm-8">
            <h3 :style="'font-size:' + font_size + 'px; text-align: ' + text_align + ';'">
                <b>{{ $t('perfil.asientos_liberados') }}: </b>
            </h3> 
        </div>               
        <div class="col-md-12 col-sm-8 scroll-table" v-if="abonado.asientos_liberados.length > 0">
            <table class="mt-3 table">
                <thead>
                    <tr>
                        <th class="text-center">{{ $t('perfil.evento') }}</th>
                        <th class="text-center">{{ $t('perfil.zona') }}</th>
                        <th class="text-center">{{ $t('perfil.fila') }}</th>
                        <th class="text-center">{{ $t('perfil.asiento') }}</th>
                        <th class="text-center">{{ $t('perfil.fecha') }}</th>
                        <th class="text-center" v-if="show_recuperar">Estado</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(asiento_liberado, index) in abonado.asientos_liberados">
                        <tr :key="index">
                            <td class="text-center">{{ asiento_liberado.evento_name }}</td>
                            <td class="text-center">{{ asiento_liberado.zona_name }}</td>
                            <td class="text-center">{{ asiento_liberado.fila }}</td>
                            <td class="text-center">{{ asiento_liberado.asiento }}</td>
                            <td class="text-center">{{ asiento_liberado.fecha }}</td>
                            <td class="text-center" v-if="show_recuperar">
                                <Button v-if="asiento_liberado.estado == 0" @click="recuperarAsiento(asiento_liberado.id)">RECUPERAR</Button>
                                <Button disabled v-else>VENDIDO</Button>
                            </td>
                        </tr>
                    </template>                    
                </tbody>
            </table>
        </div>
        <div class="col-md-12 col-sm-8" :style="'text-align: ' + text_align + ';'" v-else>
            <p>Este abonado no ha liberado ninguna butaca.</p>
        </div>
    </div>    
</template>

<script>
    export default {
        props: ['abonado', 'font_size', 'text_align', 'show_recuperar'],
        methods: {
            recuperarAsiento(id) {
                let params = {
                    abonado_id: this.abonado.id,
                    asiento_liberado_id: id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.asientos_liberados.recuperar'), params).then(res => {
                    this.$emit('actualizar');
                    this.$toast.success(res.data.message);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => this.loading = false);
            }
        }
    }
</script>

<style scoped>
    .scroll-table {
        overflow-y: scroll;
        height: 200px;
    }
</style>